import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import StatCard from "./UI/StatCard";
import { interviewSummary } from "./config/dashboardConfig";
import { getData } from "../../../../../actions/apiCall";
import one from "../../../../../assets/dash-icon/1.png";
import two from "../../../../../assets/dash-icon/2.png";
import three from "../../../../../assets/dash-icon/3.png";
import four from "../../../../../assets/dash-icon/4.png";
import five from "../../../../../assets/dash-icon/5.png";
import six from "../../../../../assets/dash-icon/6.png";

// Map your keys to images
const iconMap: Record<string, JSX.Element> = {
  FileOutlined: <img src={one} alt="icon1" className="w-10 h-10" />,
  BranchesOutlined: <img src={two} alt="icon2" className="w-10 h-10" />,
  UserOutlined: <img src={three} alt="icon3" className="w-10 h-10" />,
  MailOutlined: <img src={four} alt="icon4" className="w-10 h-10" />,
  CheckCircleOutlined: <img src={five} alt="icon5" className="w-10 h-10" />,
  CalendarOutlined: <img src={six} alt="icon6" className="w-10 h-10" />,
};

interface CountsResponse {
  [key: string]: number;
}

const InterviewSummary: React.FC = () => {
  const dispatch = useDispatch();
  const [totalCounts, setTotalCounts] = useState<CountsResponse | null>(null);

  useEffect(() => {
    getApplicantCount();
  }, []);

  const getApplicantCount = async () => {
    try {
      const response: any = await dispatch(
        getData("/analytic/deshboard/dashboard/counts")
      );

      console.log("API FULL RESPONSE ", response);
      console.log("API DATA ", response?.data);

      if (response?.data) {
        setTotalCounts(response.data);
      }
    } catch (error) {
      console.error("Dashboard count API error", error);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      <h2 className="text-lg font-semibold mb-4">Hiring Trends</h2>
      <div className="grid grid-cols-3 gap-4 overflow-y-auto pb-3">
        {interviewSummary.map((item, index) => (
          <StatCard
            key={index}
            title={item.title}
            value={item.value}
            icon={iconMap[item.icon] || <img src={one} alt="default" className="w-6 h-6" />}
          />
        ))}
      </div>
    </div>
  );
};

export default InterviewSummary;
